<template>
  <a-layout class="individual-layout">
    <IndividualInfoHeader/>
    <IndividualInfoTitle/>
    <IndividualInfoMonitorMap/>
  </a-layout>
</template>

<script>
import IndividualInfoHeader from "../../components/individualInfo/IndividualInfoHeader.vue";
import IndividualInfoTitle from "../../components/individualInfo/IndividualInfoTitle.vue";
import IndividualInfoMonitorMap from "../../components/individualInfo/IndividualInfoMonitorMap.vue";
// import { mapActions } from 'vuex';

export default {
  name: 'IndividualMonitorMapContainer',
  // data() {
  //   return {
  //    loaded: false,
  //   };
  // },
  components: {
    IndividualInfoHeader,
    IndividualInfoTitle,
    IndividualInfoMonitorMap,
  },
  // async beforeMount() {
  //   localStorage.clear();
  //   this.verifyIdentity();
  // },
  /* methods: {
    ...mapActions('identidyOpenStatus', ['deviceUidAction', 'openStatusAction']),
    ...mapActions('identidyInfo', ['identidyInfoAction']),
    async saveDeviceUid() {
        try {
          this.deviceUid = this.$route.query.data || '';
          this.deviceUidAction(this.deviceUid);
        } catch (error) {
          console.log(error);
        }
      },
    async verifyIdentity() {
        try {
          // this.isLoading = true;
          await this.saveDeviceUid();
          const params = {
            deviceUid: this.deviceUid,
          };
          const res = await this.openStatusAction(params);
          const { openedUser, carNo, openedMobile } = res;

          await this.identidyInfoAction({
            name: openedUser,
            carNo: carNo,
            phone: openedMobile,
          });
            this.loaded=true;
            // console.log(this.loaded)
        } catch (error) {
          console.log('openStatus', error);
          // this.isLoading = false;
          // this.visible = true;
        }
      },
  }, */

}
</script>
